import React from "react";
import ReactDOM from "react-dom/client";
import store, { history } from "./redux/store";
import App from "app/App";
import "./index.scss"; // Standard version
import "_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "_metronic/_assets/plugins/flaticon/flaticon.css";
import "_metronic/_assets/plugins/flaticon2/flaticon.css";
import * as serviceWorker from "./serviceWorker";

import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "_metronic/layout";
import { MetronicI18nProvider } from "_metronic/i18n";
import { ConfigProvider } from "antd";
import Highcharts from "highcharts";
import viVN from "antd/locale/vi_VN";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc"; // Import plugin UTC
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.locale("vi_VN");

dayjs.extend(relativeTime); // Sử dụng plugin

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);

Highcharts.setOptions({
  lang: {
    // Văn bản trong biểu đồ
    loading: "Đang tải...",
    months: [
      "Tháng 1",
      "Tháng 2",
      "Tháng 3",
      "Tháng 4",
      "Tháng 5",
      "Tháng 6",
      "Tháng 7",
      "Tháng 8",
      "Tháng 9",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12"
    ],
    weekdays: [
      "Chủ nhật",
      "Thứ hai",
      "Thứ ba",
      "Thứ tư",
      "Thứ năm",
      "Thứ sáu",
      "Thứ bảy"
    ],
    shortMonths: [
      "T1",
      "T2",
      "T3",
      "T4",
      "T5",
      "T6",
      "T7",
      "T8",
      "T9",
      "T10",
      "T11",
      "T12"
    ],
    decimalPoint: ",",
    thousandsSep: ".",

    // Các văn bản hỗ trợ khác
    rangeSelectorFrom: "Từ",
    rangeSelectorTo: "Đến",
    rangeSelectorZoom: "Thu phóng",
    resetZoom: "Thiết lập lại thu phóng",
    resetZoomTitle: "Thiết lập lại mức thu phóng 1:1",
    printChart: "In biểu đồ",
    downloadPNG: "Tải xuống PNG",
    downloadJPEG: "Tải xuống JPEG",
    downloadPDF: "Tải xuống PDF",
    downloadSVG: "Tải xuống SVG",

    // Thông báo lỗi và các trạng thái
    noData: "Không có dữ liệu để hiển thị",
    viewFullscreen: "Xem toàn màn hình",
    exitFullscreen: "Thoát toàn màn hình"
  }
});

const Application = (
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <ConfigProvider
            locale={viVN}
            theme={{
              hashed: false,
              token: {
                fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                colorPrimary: "#069255",
                fontSize: 14,
                colorText: "#3F4254",
                colorLink: "#069255",
                boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, .03)",
                fontWeightStrong: 500
              }
            }}
          >
            <App basename="/" history={history} store={store} />
          </ConfigProvider>
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>
);

serviceWorker.unregister();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(Application);
